import React from "react";
import OurContactUs from "../CommonContactUs/OurContactUs";
import GetInTouch from "../CommonContactUs/GetInTouch";
import EasyWAy from "../CommonContactUs/EasyWAy";

const CommonContactUs = () => {
  return (
    <div>
      <OurContactUs />
      <EasyWAy />
      <GetInTouch />
    </div>
  );
};

export default CommonContactUs;
